import { GiftCompletePage } from './GiftCompletePage'

export default GiftCompletePage
// eslint-disable-next-line import/export
export * from './GiftCompletePage'
